import Head from 'next/head';

type MetadataComponentProps = {
    title: string,
    description: string
}

const MetadataComponent = ({ title, description }: MetadataComponentProps) => {
    return (
        <Head>
            <title>{title}</title>
            <meta name="description" content={description} />
        </Head>
    )
}

export default MetadataComponent